var _defs, _rect, _path, _path2, _ellipse, _ellipse2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 141.73 141.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2,.cls-3,.cls-5{opacity:0.39;}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 43.11,
    y1: 70.87,
    x2: 98.62,
    y2: 70.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a0ddea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6bcbd2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 43.11,
    y1: 70.87,
    x2: 55.49,
    y2: 70.87,
    gradientTransform: "translate(-10.99 13.04) rotate(-9.76)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#47bdc6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00737c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 8409.63,
    y1: 1659.52,
    x2: 8465.13,
    y2: 1659.52,
    gradientTransform: "translate(-8359 -1545.01)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 68.71,
    y1: 115.16,
    x2: 77.02,
    y2: 115.16,
    gradientTransform: "translate(7.48 -0.98)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 52.85,
    y1: 25.14,
    x2: 55.7,
    y2: 25.14,
    gradientTransform: "translate(-7.51 3.48)",
    xlinkHref: "#linear-gradient-2"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 4 copy 15") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 43.11,
    y: 18.04,
    width: 55.5,
    height: 105.66,
    rx: 8.38,
    transform: "translate(-10.99 13.04) rotate(-9.76)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55,118.7,39.92,31.09a8.38,8.38,0,0,1,6.84-9.68l-3.94.68A8.38,8.38,0,0,0,36,31.77l15.07,87.61a8.38,8.38,0,0,0,9.68,6.83l3.94-.67A8.39,8.39,0,0,1,55,118.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M59,106H97.78a8.34,8.34,0,0,1,8.34,8.34v8.73a0,0,0,0,1,0,0H50.62a0,0,0,0,1,0,0v-8.73A8.34,8.34,0,0,1,59,106Z",
    transform: "translate(175.03 214.08) rotate(170.24)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 80.35,
    cy: 114.17,
    rx: 4.15,
    ry: 4.81,
    transform: "matrix(0.99, -0.17, 0.17, 0.99, -18.19, 15.28)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 46.76,
    cy: 28.61,
    rx: 1.42,
    ry: 1.67,
    transform: "translate(-4.17 8.34) rotate(-9.76)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.7bc581dd84a1d012f7d33af6b2da1cb0.svg";
export { ForwardRef as ReactComponent };